import { Dictionary } from 'guest-app-ui';
import { ApiServiceResponse } from '../api.models';

export enum PhoneType {
	HOME = 'HOM',
	MOBILE = 'MOB',
}

export interface Address {
	city: string;
	co_dept?: string;
	country: string;
	state: string;
	street: string;
	zip: string;
	type?: string;
}

export interface Phone {
	country_code?: string;
	number: string;
	pToken: string;
	region_code?: string;
	type?: PhoneType;
}

export interface Email {
	address: string;
	eToken: string;
	opt_in?: string;
}

export interface Customer {
	cToken: string;
	first_name: string;
	id: string;
	index: string;
	last_name: string;
	name: string;
	shipping_name?: string;
	ADDRESS: Address;
	PHONE: Phone[];
	EMAIL: Email[];
}

export interface CustomerDetailsReply {
	status: string;
	CUSTOMER: Customer[];
}

export enum PaymentStatus {
	PAID = 'paid',
	CANCELLED = 'cancelled',
	DECLINED = 'declined',
}

export interface ScheduledPayment {
	amount: string;
	amount_remaining?: string;
	date?: Date;
	is_future_payment: string;
	status: string;
	AMT?: DeclinedNode[];
}

export interface DeclinedNode {
	amount: string;
	date?: string;
	name: string;
}
export interface Card {
	index: string;
	last_four: string;
	type: string;
}

export interface ScheduledPayments {
	late_fee_amount: string;
	status?: string;
	remaining_balance: string;
	total_amount: string;
	has_camp_deposit?: string;
	is_within_compulsory_period: string;
	compulsory_period_end_date: string;
	remaining_compulsory_amount: string;
	amount_owed: string;
	SP: ScheduledPayment[];
	paid_compulsory_amount: string;
	total_compulsory_amount: string;
}

export interface PackageType {
	type: string;
}

export interface PaymentPortalLogin extends ApiServiceResponse {
	CUSTOMER_DETAILS_REPLY?: CustomerDetailsReply[];
	SCHEDULED_PAYMENTS?: ScheduledPayments[];
	CARD?: Card[];
	PKG?: PackageType[];
	billing_provider_id?: string;
	billing_provider_desc?: string;
	cc_payment_type?: string;
	cepay_merchant_id?: string;
	jwt?: string;
	merchant_id?: string;
	payment_type?: string;
	support_secondary_payment?: string;
	cancellation_effective_date?: string;
}

export interface PaymentPortalLoginResponse {
	SERVICE: PaymentPortalLogin;
}

export interface LoginInfo {
	order_id: string;
	email: string;
	mfa_code?: string;
	user_token?: string;
	utToken?: string;
	uidToken?: string;
}

export interface PaymentPortalLoginResponseAction {
	customData: Dictionary<any>;
	isOkay: boolean;
	params: LoginInfo;
	requestType: string;
	response: PaymentPortalLogin;
	status: string;
	type: string;
}
